/**
 * Role slugs as they appear in `state.auth.user.roles`. PartnerNet derives
 * them from the user's security groups via dbo.slugify(LOWER(Name)).
 */
export const SYSTEM_SELECTOR_ADMIN_ROLE = 'system-selector-administrators';
